import type { IProfile } from '@setplex/tria-api'
import type { Location } from 'history'
import type { ReturnLocation } from './index.h'

import { PROFILES } from '~/shared/routes'

export const hasRegularProfile = (profiles: IProfile[]): boolean => {
  return profiles.some((profile) => !profile.kidsProfile)
}

export const extractManageTail = (pathname?: string | null) => {
  if (!pathname) return null
  const matched = pathname.match(/~(.*)$/)
  const tail = matched?.[1]
  if (!tail) return null
  return tail.startsWith('/') ? tail : `/${tail}`
}

export const withManageTail = ({
  base,
  locationPathname,
  returnLocation,
}: {
  base: string
  locationPathname?: string
  returnLocation: { pathname: string } | null
}) => {
  const tailFromLocation = locationPathname?.match(/~(.*)$/)?.[1]
  let tail: string | null = null

  if (tailFromLocation) {
    tail = tailFromLocation.startsWith('/')
      ? tailFromLocation
      : `/${tailFromLocation}`
  } else if (returnLocation?.pathname) {
    tail = returnLocation.pathname
  }

  return tail ? buildManagePathWithTail(base, tail) : base
}

export function buildManagePathWithTail(
  currentPathname: string,
  previousPathname: string
) {
  const head = currentPathname.replace(/~.*$/, '')
  const delimeter = head.endsWith('/') ? '~' : '/~'
  const tail = previousPathname === '/' ? '' : `${delimeter}${previousPathname}`
  return `${head}${tail}`
}

export function buildChoosePathWithTail(currentPathname?: string) {
  const splitted = currentPathname?.split('/~')
  const head = PROFILES.CHOOSE
  const tail = splitted?.[1]
  return tail ? `${head}/${tail}` : head
}

interface NavigateEditProfileParams {
  location: Location | null
  back: ReturnLocation | null
  id: number
  selectMode?: boolean
}
export const navigateEditProfile = ({
  location,
  back,
  id,
  selectMode,
}: NavigateEditProfileParams) => {
  if (PROFILES.isChoose(location?.pathname)) {
    return {
      ...location,
      pathname: location?.pathname?.replace(
        PROFILES.segments.CHOOSE,
        `${PROFILES.segments.EDIT}/${id}`
      ),
    }
  }

  const base = PROFILES.manageEdit(id)
  return {
    ...location,
    pathname: withManageTail({
      base,
      locationPathname: location?.pathname,
      returnLocation: back,
    }),
    search: selectMode ? '?selectMode=true' : '',
  }
}
